import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  SortHeaderAlignType,
  Table,
  TableBody,
  TableCell,
  TableHeadSort,
  TableHeader,
  TableNoResults,
  TableRow,
} from '@ui/v2/Table/Table'

import { PageQuery } from '@utils/ApiClient'
import { getContestPoints } from '@utils/format.utils'

import { ClientContestCampaignDetailDto } from '@model/ClientContestCampaignDetailDto'
import { ClientContestCampaignResultDto } from '@model/ClientContestCampaignResultDto'
import { NameDto } from '@model/NameDto'

import { useFormatNumber } from '@hooks/useFormatNumber'

import styles from '../Rebate/CampaignRebateCard.module.scss'

interface CampaignContestTableProps {
  sortOptions: (NameDto<string> & { align?: SortHeaderAlignType })[]
  data: ClientContestCampaignResultDto[]
  campaignDetails: ClientContestCampaignDetailDto
  pageQuery?: PageQuery
  setPageQuery(value: PageQuery): void
  campaignContestPointsSymbol: string
  isLoading?: boolean
  sticky?: 'left'
}

export const CampaignContestTable: React.FC<CampaignContestTableProps> = (props) => {
  const {
    sortOptions,
    data,
    campaignDetails,
    pageQuery,
    setPageQuery,
    campaignContestPointsSymbol,
    isLoading = false,
    sticky,
  } = props

  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()

  return (
    <Table
      isLoading={isLoading}
      sticky={sticky}
      noResults={!data.length && <TableNoResults title={t('No results found')} />}
    >
      <TableHeader>
        <TableRow>
          {sortOptions.map((x) => (
            <TableHeadSort
              align={x.align || 'center'}
              id={x.id}
              sort={pageQuery?.sort || undefined}
              sortOrder={pageQuery?.sortOrder}
              setSort={(sort, sortOrder) => {
                setPageQuery({
                  ...(pageQuery || {}),
                  sort,
                  sortOrder,
                })
              }}
            >
              {x.name}
            </TableHeadSort>
          ))}
        </TableRow>
      </TableHeader>

      <TableBody>
        {data.map((roundResult) => (
          <TableRow
            className={classNames({
              [styles.resultCurrentRanking]:
                roundResult.name === campaignDetails.tradingAccount.name,
            })}
          >
            <TableCell>
              {!isDisqualifiedRanking(roundResult) ? `#${roundResult.ranking}` : t('N/A')}
            </TableCell>
            <TableCell>{roundResult.name}</TableCell>
            <TableCell>
              {getContestPoints(roundResult.points, campaignContestPointsSymbol, formatMoney)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

const isDisqualifiedRanking = (data: ClientContestCampaignResultDto) => data.ranking === -1
